module.exports = __webpack_public_path__ + "img/banner-1.76c21a6e.png";